import { render } from "./ForgotPinPage.vue?vue&type=template&id=1d670a46"
import script from "./ForgotPinPage.vue?vue&type=script&lang=js"
export * from "./ForgotPinPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__